import styled from 'styled-components';

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.65rem;
`;
